import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';

import type {
  CreateModeloAndamentoDto,
  UpdateModeloAndamentoDto,
} from '../types/modeloAndamentoTypes';

import { modelosAndamentoService } from './services';

export const listarModelosAndamento = createAsyncThunk(
  'modelosAndamento/listar',
  async (_void: void, { rejectWithValue }) => {
    try {
      return await modelosAndamentoService.listar();
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const listarVariaveisAndamento = createAsyncThunk(
  'modelosAndamento/listarVariaveis',
  async (_void: void, { rejectWithValue }) => {
    try {
      return await modelosAndamentoService.listarVariaveis();
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarModeloAndamento = createAsyncThunk(
  'modelosAndamento/criar',
  async (data: CreateModeloAndamentoDto, { rejectWithValue }) => {
    try {
      return await modelosAndamentoService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarModeloAndamento = createAsyncThunk(
  'modelosAndamento/atualizar',
  async ({ id, data }: { id: string; data: UpdateModeloAndamentoDto }, { rejectWithValue }) => {
    try {
      return await modelosAndamentoService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const alternarStatusModeloAndamento = createAsyncThunk(
  'modelosAndamento/alternarStatus',
  async (id: string, { rejectWithValue }) => {
    try {
      return await modelosAndamentoService.alternarStatus(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
